var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "350 340 700 10",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b6cd",
    d: "M506.1 165.2L564 311l98 38-100 54-55.9 190L918 339z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.1 141.6l-18.9 6.9L546.8 321c2.1 5.8 6.8 10.3 12.7 12.3l64 21-73 31.9c-5.5 2.4-9.6 7.1-11.3 12.9l-55.4 191.8c-2.3 8 .5 16.6 7.2 21.6 6.6 5 15.7 5.5 22.8 1.1l418.8-259.3c6.3-3.9 9.9-10.9 9.5-18.3-.4-7.4-4.9-13.9-11.6-17.1L511.6 123.3c-7.4-3.4-16.1-2.1-22.1 3.4s-8.1 14.1-5.3 21.7l18.9-6.8-8.5 18.2 385 179.6-342.7 212.3 38.2-132.5 112.7-49.3c7.6-3.3 12.4-11.1 12-19.4-.4-8.3-5.9-15.6-13.8-18.2L581.2 298 522 134.7l-18.9 6.9-8.5 18.2 8.5-18.2z",
    fill: "#00b6cd"
  })));
}

export default SvgSend;